package com.appcreator.client.firebase.auth

import androidx.compose.runtime.mutableStateOf
import com.appcreator.blueprint.firebase.auth.FirebaseAuthConsts
import com.appcreator.blueprint.firebase.auth.FirebaseAuthDeleteUserAction
import com.appcreator.blueprint.firebase.auth.FirebaseAuthLoggedInCondition
import com.appcreator.blueprint.firebase.auth.FirebaseAuthLoginAction
import com.appcreator.blueprint.firebase.auth.FirebaseAuthLogoutAction
import com.appcreator.blueprint.firebase.auth.FirebaseAuthResetPasswordAction
import com.appcreator.blueprint.firebase.auth.FirebaseAuthSetDisplayNameAction
import com.appcreator.blueprint.firebase.auth.FirebaseAuthSignInWithApple
import com.appcreator.blueprint.firebase.auth.FirebaseAuthSignInWithGoogle
import com.appcreator.blueprint.firebase.auth.FirebaseAuthSignUpAction
import com.appcreator.compose.di.Container
import com.appcreator.compose.events.LoginEvent
import com.appcreator.compose.events.PurchaseEvent
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlin.time.Duration.Companion.seconds

object FirebaseAuthInitializer {

    fun initialize() {
        Container.registerCondition(FirebaseAuthLoggedInCondition::class) {
            LoggedInEvaluator(it)
        }

        Container.registerAction(FirebaseAuthDeleteUserAction::class) {
            DeleteUserPerformer(it)
        }
        Container.registerAction(FirebaseAuthLoginAction::class) {
            LoginPerformer(it)
        }
        Container.registerAction(FirebaseAuthLogoutAction::class) {
            LogoutPerformer(it)
        }
        Container.registerAction(FirebaseAuthResetPasswordAction::class) {
            ResetPasswordPerformer(it)
        }
        Container.registerAction(FirebaseAuthSignUpAction::class) {
            SignUpPerformer(it)
        }
        Container.registerAction(FirebaseAuthSetDisplayNameAction::class) {
            SetDisplayNamePerformer(it)
        }
        Container.registerAction(FirebaseAuthSignInWithApple::class) {
            SignInWithApplePerformer(it)
        }
        Container.registerAction(FirebaseAuthSignInWithGoogle::class) {
            SignInWithGooglePerformer(it)
        }

        val userId = mutableStateOf(Firebase.auth.currentUser?.uid ?: "")
        Container.globalKeys[FirebaseAuthConsts.uid] = userId

        val userDisplayName = mutableStateOf(Firebase.auth.currentUser?.displayName ?: "")
        Container.globalKeys[FirebaseAuthConsts.userDisplayName] = userDisplayName

        val userAuthToken = mutableStateOf("")
        Container.globalKeys[FirebaseAuthConsts.userToken] = userAuthToken


        Container.addBusConsumer {
            if(it is PurchaseEvent) {
                GlobalScope.launch {
                    try {
                        // Wait for backend processing to update user entitlements
                        delay(5.seconds)
                        Firebase.auth.currentUser?.getIdToken(true)
                    } catch (ex: Exception) {
                        println("Error updating token ${ex.message}")
                    }
                }
            }
        }

        // This is likely a bad idea I think we need suspend env functions that can be used not
        // convinced the observing below will guarantee this is up to date
        Container.headerProviders.add {
            "Authorization" to "Bearer ${Firebase.auth.currentUser?.getIdToken(false)}"
        }

        GlobalScope.launch {
            Firebase.auth.authStateChanged.collect {
                userId.value = it?.uid?: ""
                userDisplayName.value = it?.displayName?: ""
                try {
                    Container.sendEvent(LoginEvent(it?.uid, it?.email, it?.displayName))
                } catch (ex: Exception) {
                    println("Error sending user update ${ex.message}")
                }
            }
        }
        GlobalScope.launch {
            Firebase.auth.idTokenChanged.collect {
                try {
                    userAuthToken.value = it?.getIdToken(false) ?: ""
                } catch (ex: Exception) {
                    println("Failed to update auth token after change ${ex.message}")
                }
            }
        }
        platformAuthInitialize()
    }
}

internal expect fun platformAuthInitialize()
